var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 375,
    viewBox: "0 120 375 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 320.67C267.812 320.67 332.918 316.869 332.918 312.18C332.918 307.492 267.812 303.69 187.5 303.69C107.188 303.69 42.0825 307.492 42.0825 312.18C42.0825 316.869 107.188 320.67 187.5 320.67Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9299 217.61H98.1799V227.69H98.9299V217.61Z",
    fill: "#E47100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9299 230.69H98.1799V234.86H98.9299V230.69Z",
    fill: "#E47100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.805 180.771H223.452V312.373H104.315C103.386 312.373 102.495 312.004 101.838 311.347C101.181 310.69 100.812 309.799 100.812 308.87V180.771H100.805Z",
    fill: "#E47100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223.452 180.771H100.805V190.101H171.372L173.712 312.373L175.347 190.101H223.452V180.771Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7475 160.768H223.453V187.438H99.7475C99.2841 187.438 98.8396 187.253 98.5118 186.926C98.1841 186.598 98 186.154 98 185.69V162.523C97.999 162.292 98.0435 162.064 98.1309 161.852C98.2183 161.639 98.3468 161.445 98.5092 161.282C98.6716 161.119 98.8645 160.99 99.077 160.901C99.2895 160.813 99.5174 160.768 99.7475 160.768V160.768Z",
    fill: "#E47100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.033 312.373L146.75 160.768H173.42L174.695 312.373H148.033Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.79 312.373H223.482V180.771H275.27V308.871C275.27 309.796 274.904 310.683 274.252 311.339C273.6 311.995 272.715 312.367 271.79 312.373V312.373Z",
    fill: "#E47100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.79 312.373H223.482V180.771H275.27V308.871C275.27 309.796 274.904 310.683 274.252 311.339C273.6 311.995 272.715 312.367 271.79 312.373V312.373Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223.453 180.771H275.263V190.101H246.35L242.42 312.373L242.848 190.101H223.453V180.771Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.328 187.437H223.453V160.768H276.328C276.557 160.768 276.784 160.813 276.996 160.901C277.208 160.988 277.401 161.117 277.563 161.279C277.726 161.442 277.854 161.634 277.942 161.846C278.03 162.058 278.075 162.286 278.075 162.515L278.075 185.683C278.076 185.913 278.032 186.141 277.944 186.354C277.857 186.566 277.728 186.76 277.566 186.923C277.404 187.086 277.211 187.215 276.998 187.304C276.786 187.392 276.558 187.438 276.328 187.437V187.437Z",
    fill: "#E47100"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.328 187.437H223.453V160.768H276.328C276.557 160.768 276.784 160.813 276.996 160.901C277.208 160.988 277.401 161.117 277.563 161.279C277.726 161.442 277.854 161.634 277.942 161.846C278.03 162.058 278.075 162.286 278.075 162.515L278.075 185.683C278.076 185.913 278.032 186.141 277.944 186.354C277.857 186.566 277.728 186.76 277.566 186.923C277.404 187.086 277.211 187.215 276.998 187.304C276.786 187.392 276.558 187.438 276.328 187.437V187.437Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.42 312.373L244.655 160.768H261.298L259.063 312.373H242.42Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.42 312.373L244.655 160.768H261.298L259.063 312.373H242.42Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.105 110.443V110.405H229.288C228.032 110.51 226.806 110.845 225.673 111.395C203.548 120.665 192.793 144.958 188.038 160.738H210.358C210.358 160.738 263.18 108.943 251.105 110.443Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.358 160.768C210.358 140.271 225.868 120.696 247.993 111.426C270.118 102.156 210.358 160.768 210.358 160.768Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.805 123.426H240.612C239.579 123.514 238.566 123.768 237.612 124.176C218.532 131.061 203.585 149.098 195.522 160.813H212.097C212.097 160.813 266.202 122.301 256.805 123.426Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.127 160.768C219.935 140.518 235.137 131.015 254.217 124.13C273.297 117.245 212.127 160.768 212.127 160.768Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.77 104.045V104H125.9C125.499 103.993 125.104 104.092 124.754 104.289C124.405 104.485 124.114 104.771 123.912 105.118C117.087 115.565 146.412 142.963 167.735 160.76H190.055C190.055 160.76 157.355 102.343 147.77 104.045Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M190.055 160.767C168.762 142.97 139.407 115.572 146.232 105.125C153.057 94.6773 190.055 160.767 190.055 160.767Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.57 118.693H154.34C154.013 118.701 153.691 118.779 153.396 118.921C153.101 119.063 152.84 119.267 152.63 119.518C145.4 127.28 161.51 147.628 173.63 160.835H190.183C190.183 160.835 178.033 117.388 170.57 118.693Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M190.183 160.768C178.063 147.553 161.945 127.213 169.183 119.451C176.42 111.688 190.183 160.768 190.183 160.768Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.f6cf849958b975348509d5e7c842c286.svg";
export { ForwardRef as ReactComponent };